<template>
  <div class="content">
    <div class="list">
      <div class="list-item" v-for="(item, index) in navList" :key="index"
        :style="isActive == index ? activeStyleObj : ''" @click="selectNav(index, item.url)">
        <img :src="isActive == index ? item.imageActive : item.image" alt="">
        <div>{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import slideActiveImg from '@/assets/img/promotion/slide_active.png'
export default {
  name: "SaasSildeNav",
  data() {
    return {
      navList: [{
        text: '主页',
        image: require('@/assets/img/promotion/promote_btn_home_n.png'),
        imageActive: require('@/assets/img/promotion/promote_btn_home_s.png'),
        url: '/pc/SaasJoin/home/index'
      },
      {
        text: '电影票订单',
        image: require('@/assets/img/promotion/promote_btn_order_n.png'),
        imageActive: require('@/assets/img/promotion/promote_btn_order_s.png'),
        url: '/pc/SaasJoin/movieOrderList/index'
      },
      {
        text: '用户列表',
        image: require('@/assets/img/leftbar_icon_user_n.png'),
        imageActive: require('@/assets/img/leftbar_icon_user_s.png'),
        url: '/pc/SaasJoin/userList/index'
      },
      {
        text: '套餐订单',
        image: require('@/assets/img/leftbar_icon_combo_n.png'),
        imageActive: require('@/assets/img/leftbar_icon_combo_s.png'),
        url: '/pc/SaasJoin/setTheOrder/index'
      },
      {
        text: '公众号授权',
        image: require('@/assets/img/official/leftbar_btn_wechat_n.png'),
        imageActive: require('@/assets/img/official/leftbar_btn_wechat_s.png'),
        url: '/pc/SaasJoin/official/index'
      },
      {
        text: '票务号入驻',
        image: require('@/assets/img/leftbar_icon_combo_n.png'),
        imageActive: require('@/assets/img/leftbar_icon_combo_s.png'),
        url: '/pc/SaasJoin/ticketIn/index'
      }, {
        text: '指派规则',
        image: require('@/assets/img/leftbar_icon_designate_s.png'),
        imageActive: require('@/assets/img/leftbar_icon_designate_n.png'),
        url: '/pc/SaasJoin/assignRules/index'
      },
      {
        text: '资金明细',
        image: require('@/assets/img/official/leftbar_btn_earnings_n.png'),
        imageActive: require('@/assets/img/official/leftbar_btn_earnings_s.png'),
        url: '/pc/SaasJoin/financialDetails/index'
      },
      {
        text: '影票定价',
        image: require('@/assets/img/leftbar_icon_pricing_n.png'),
        imageActive: require('@/assets/img/leftbar_icon_pricing_s.png'),
        url: '/pc/SaasJoin/moviePriceList/index'
      },
      ],
      isActive: 0, //默认选中
      // 选中样式
      activeStyleObj: {
        backgroundImage: 'url(' + slideActiveImg + ')',
        color: '#fff'
      },
    }
  },
  mounted() {
    this.getUrl()
  },
  methods: {
    // 跳转到对应页面
    selectNav(index, url) {
      this.isActive = index
      this.$router.push(url)
    },
    // 获取当前页面路径并判断是否当前页面高亮
    getUrl() {
      let url = this.$route.path
      if (url == '/pc/SaasJoin/moviePriceList/index') {
        this.isActive = 0
      }
      if (url == '/pc/SaasJoin/movieOrderList/index') {
        this.isActive = 1
      }
      if (url == '/pc/SaasJoin/userList/index') {
        this.isActive = 2
      }
      if (url == '/pc/SaasJoin/setTheOrder/index') {
        this.isActive = 3
      }
      if (url == '/pc/SaasJoin/official/index') {
        this.isActive = 4
      }
      if (url == '/pc/SaasJoin/ticketIn/index') {
        this.isActive = 5
      }
      if (url == '/pc/SaasJoin/assignRules/index') {
        this.isActive = 6
      }
      if (url == '/pc/SaasJoin/financialDetails/index') {
        this.isActive = 7
      }
      if (url == '/pc/SaasJoin/moviePriceList/index') {
        this.isActive = 8
      }
    }
  }
}
</script>

<style scoped lang="less">
.content {
  width: 220px;
  height: 100%;
  min-height: 1069px;
  background: #FDFDFD;
  border-radius: 8px;

  .list {
    .list-item {
      display: flex;
      align-items: center;
      padding: 14px 24px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/components/SaasSildeNav.vue